import styled from "styled-components";
import CustomButton from "./CustomButton";
import { IMAGES } from "../../constants/images";
import ExpandedMenu from "./ExpandedMenu/ExpandedMenu";
import OpenWarningModal from "../WarningModal/OpenWarningModal";

export default function DrawToolSecondMode({
  toggleDrawMode,
  drawMode,
  toggleDrawModePoint,
  clearHandler,
  toggleDrawModeHome,
  handleExpanded,
  isExpanded,
  applyPreset,
  country,
  deleteDisabled,
  handleContextualDelete,
  bufferDistances,
  handlePlus,
  handleMinus,
  setBufferDistances,
  selectedRiskId,
  selectedRiskLabel,
  setSelectedRiskLabel,
  refreshMeasurementsNow,
  refreshRiskDriverLabels,
  setSelectedRiskId,
  handleOpenFireFenceParams,
  handleInitialAsessmentParams,
}) {
  return (
    <DrawToolContainer>
      <CustomButton title="Draw lot perimeter" src={IMAGES.POLYGON} alt="Polygon" isActive={drawMode.area === "draw_polygon"} onClick={toggleDrawMode} />
      <ExpandedMenu
        toggleDrawModeHome={toggleDrawModeHome}
        drawMode={drawMode}
        handleExpanded={handleExpanded}
        isExpanded={isExpanded}
        applyPreset={applyPreset}
        country={country}
        deleteDisabled={deleteDisabled}
        handleContextualDelete={handleContextualDelete}
        bufferDistances={bufferDistances}
        handlePlus={handlePlus}
        handleMinus={handleMinus}
        setBufferDistances={setBufferDistances}
      />
      <CustomButton title="Add label" src={IMAGES.TREE} alt="Tree" onClick={toggleDrawModePoint} isActive={drawMode.point === "draw_point"} />
      {selectedRiskId && (
        <RiskDriverInput>
          <input
            type="text"
            value={selectedRiskLabel}
            onChange={(e) => {
              const val = e.target.value;
              setSelectedRiskLabel(val);
              window.draw.setFeatureProperty(selectedRiskId, "label", val);
              refreshRiskDriverLabels();
            }}
          />
          <button
            onClick={() => {
              window.draw.delete(selectedRiskId);
              setSelectedRiskId(null);
              setSelectedRiskLabel("");
              refreshRiskDriverLabels();
              refreshMeasurementsNow();
            }}
          >
            <img src={IMAGES.CLOSE} alt="Bin" />
          </button>
        </RiskDriverInput>
      )}
      <OpenWarningModal action={clearHandler}>
        <CustomButton title="Clear" src={IMAGES.BIN} alt="Bin" />
      </OpenWarningModal>
      <CustomButton title="Calculate" src={IMAGES.CALCULATE} alt="Calculate" onClick={() => handleInitialAsessmentParams(true)} />
      <CustomButton title="FireFence Parameters" src={IMAGES.FIRE} alt="Fire" onClick={() => handleOpenFireFenceParams(true)} />
    </DrawToolContainer>
  );
}

const DrawToolContainer = styled.div`
  display: grid;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  gap: 10px;
  padding: 15px;
  border-radius: 5px;
  font-size: 14px;
`;

const RiskDriverInput = styled.div`
  display: flex;
  height: 24px;
  gap: 5px;

  button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 24px;
    cursor: pointer;
    border-radius: 5px;
    background-color: white;
    transition: background-color 0.3s;
  }

  button:hover {
    background-color: #ececec;
  }

  input {
    all: unset;
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 0 10px;
  }

  input:focus {
    outline: 2px solid #0f77ffff;
  }
`;
